var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0609 13.2402V7.68536C20.0609 6.58079 19.1655 5.68536 18.0609 5.68536H11.9458C10.8412 5.68536 9.9458 6.58079 9.9458 7.68536V13.2402",
    stroke: "url(#paint0_linear_79_566)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97844 12.9015C6.62325 12.6432 6.125 12.8969 6.125 13.3361V22.9995C6.125 24.6564 7.46814 25.9995 9.125 25.9995H22.1202C23.777 25.9995 25.1202 24.6564 25.1202 22.9995V22.0952H22.0971C20.7063 22.0952 19.5788 20.9677 19.5788 19.5769C19.5788 18.1861 20.7063 17.0586 22.0971 17.0586H25.1202V16.3361C25.1202 14.6792 23.777 13.3361 22.1202 13.3361H15.6226H10.8738H8.4994H7.83091C7.66525 13.3361 7.50385 13.2836 7.36988 13.1862L6.97844 12.9015Z",
    fill: "url(#paint1_linear_79_566)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0605 9.38154H22.5788C23.2742 9.38154 23.838 9.97211 23.838 10.7006V13.3389H8.0147C6.97158 13.3389 6.12598 12.453 6.12598 11.3602C6.12598 10.2674 6.97158 9.38154 8.0147 9.38154H9.94539",
    stroke: "#302F3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.667,
    y: 5.68799,
    width: 2.63822,
    height: 7.65083,
    fill: "url(#paint2_linear_79_566)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12598 11.3514V23.4245C6.12598 24.8233 7.25489 25.9995 8.64746 25.9995H23.8604C24.5567 25.9995 25.1211 25.4325 25.1211 24.7331V22.1581",
    stroke: "#302F3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1199 17.0327V14.5568C25.1199 13.8843 24.5293 13.3392 23.8008 13.3392",
    stroke: "#302F3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0989 21.5977H25.3763V17.5611H22.0989C20.9842 17.5611 20.0806 18.4647 20.0806 19.5794C20.0806 20.694 20.9842 21.5977 22.0989 21.5977Z",
    stroke: "url(#paint3_linear_79_566)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7274 19.5765C22.7274 19.9242 22.4455 20.2061 22.0978 20.2061C21.7501 20.2061 21.4683 19.9242 21.4683 19.5765C21.4683 19.2288 21.7501 18.9469 22.0978 18.9469C22.4455 18.9469 22.7274 19.2288 22.7274 19.5765Z",
    fill: "#AAECD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0609 12.2695V7.68611C20.0609 6.58154 19.1655 5.68611 18.0609 5.68611H11.8968C10.8115 5.68611 9.92444 6.55048 9.90106 7.63547C9.86849 9.14644 9.83008 11.1633 9.83008 12.2695",
    stroke: "#7DAB9D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_566",
    x1: 15.0034,
    y1: 13.2402,
    x2: 15.0034,
    y2: 5.68536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871868,
    stopColor: "#AAECD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_566",
    x1: 6.125,
    y1: 25.9995,
    x2: 23.5192,
    y2: 10.9476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_566",
    x1: 12.9861,
    y1: 6.07053,
    x2: 12.9861,
    y2: 13.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_566",
    x1: 22.7284,
    y1: 21.8458,
    x2: 22.7284,
    y2: 17.0611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiatIcon);
export default __webpack_public_path__ + "static/media/fiatIcon.b0726fec8711f29d4a247e8eb42ec7ac.svg";
export { ForwardRef as ReactComponent };